import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/database';

var firebaseConfig = {
  apiKey: 'AIzaSyAWcDSRZuR_CEj88Qhhcg_PTGjhNDe1q1M',
  authDomain: 'pex-chat.firebaseapp.com',
  databaseURL: 'https://pex-chat.firebaseio.com',
  projectId: 'pex-chat',
  storageBucket: 'pex-chat.appspot.com',
  messagingSenderId: '52550450369',
  appId: '1:52550450369:web:81f142ecf0f23e0b'
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
